<template>
    <div class="header__search">
      <form role="search" method="get" class="header__search-form" action="/search">
        <label>
          <span class="hide-content">{{ $t('search.search_for') }}</span>
          <input type="search" class="header__search-field" :placeholder="$t('search.type_keywords')" value="" name="s" title="Search for:" autocomplete="off">
        </label>
        <input type="submit" class="header__search-submit" :value="$t('navigation.search')">
      </form>
      <a href="javascript:void(0)" title="Close Search" class="header__search-close">{{ $t('navigation.close_search') }}</a>
    </div>
  </template>
  
  <script>
  export default {
    mounted() {
      this.initSearch();
    },
    methods: {
      initSearch() {
        var searchWrap = $('.header__search'),
            searchField = searchWrap.find('.search-field'),
            closeSearch = searchWrap.find('.header__search-close'),
            searchTrigger = $('.header__search-trigger'),
            siteBody = $('body');
  
        searchTrigger.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            siteBody.addClass('search-is-visible');
            setTimeout(function(){
                searchWrap.find('.search-field').focus();
            }, 100);
        });
  
        closeSearch.on('click', function(e) {
            e.stopPropagation(); 
            if(siteBody.hasClass('search-is-visible')){
                siteBody.removeClass('search-is-visible');
                setTimeout(function(){
                    searchWrap.find('.search-field').blur();
                }, 100);
            }
        });
  
        searchWrap.on('click',  function() { });
  
        searchField.on('click', function(e){
            e.stopPropagation();
        });
  
        searchField.attr({placeholder: 'Type Keywords', autocomplete: 'off'});
      }
    }
  };
  </script>
  